import React, { useState, useEffect, FC } from 'react';
import classnames from 'classnames';
import { ImageProps } from './props';
import './styles.scss';

export const Image: FC<ImageProps> = ({ src, alt, className, style, setDefaultState }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // On source change set the status back to pending state.
  useEffect(() => {
    setIsLoaded(false);
  }, [src]);

  return (
    <img
      alt={alt}
      className={classnames('fr-image', isLoaded && 'fr-image--loaded', className)}
      onError={() => setDefaultState?.()}
      onLoad={() => setIsLoaded(true)}
      src={src}
      style={style}
    />
  );
};
